((global) => {
  function create({ add, hydrate, onState = () => {} }) {
    let pending = false;
    let confirmedUnhydrated = false;

    async function run(payload) {
      if (pending) return { status: 'suppressed_pending' };
      if (confirmedUnhydrated) return { status: 'suppressed_partial_success' };
      pending = true;
      onState('adding');
      let addedItem;
      try {
        addedItem = await add(payload);
      } catch (error) {
        onState('add_error', error);
        pending = false;
        return { status: 'add_error', error };
      }

      onState('added', addedItem);
      try {
        const cart = await hydrate();
        onState('success', cart);
        pending = false;
        return { status: 'success', cart };
      } catch (error) {
        confirmedUnhydrated = true;
        onState('partial_success', error);
        pending = false;
        return { status: 'partial_success', error };
      }
    }

    function state() { return Object.freeze({ pending, confirmedUnhydrated }); }
    return Object.freeze({ run, state });
  }

  global.MoveCalmlyProductAddState = Object.freeze({ create });
})(window);
